import styled from "styled-components";
import { colors } from "../../../theme/colors";

export const FloatingActionButton = styled.button`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  background-image: linear-gradient(90deg, #438dc7 0%, #205496 100%);
  border-radius: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.6rem;
  font-weight: 600;
  z-index: 3;
  color: ${colors.white.hex};
  gap: 1rem;
  padding: 1.5rem 2.5rem;
  border: none;
  outline: none;
  cursor: pointer;
  box-shadow: 2px 2px 40px 0 rgba(32, 84, 150, 0.32);
  transition: all 0.3s;

  &:hover {
    transform: translateY(-0.2rem);
  }

  @media only screen and (max-width: 48em) {
    font-size: 1.4rem;
  }
`;
